import type { LovProADTO } from '@/features/api/extranet/dto/Demande/PROA'
import {
  getNaturesFichiersProa as getNaturesFichiers,
  propertyStatusConfiguration,
  reglesConfiguration,
} from '@/features/domaine/regles-akto/PROA'
import { proaService } from '@/features/services/demande'
import { buildDemandeStore } from '../shared'

export const useDemandePROAStore = buildDemandeStore<'MODEL_PROA', LovProADTO>({
  model: 'MODEL_PROA',
  typeDemande: 'Formation',
  module: 'demande',
  demandeService: proaService,
  propertyStatusConfiguration,
  reglesConfiguration,
  getNaturesFichiers,
})

